import {Component, Inject, OnInit,} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {AlertService, AuthenticationService, ProjectControlItemService, ProjectService,} from '../../_services/index';

import {Project, ProjectControlItem} from '../../_models/index';

import {MatDialogConfig} from '@angular/material/dialog';

import {LoginHelper} from '../../helpers';
import {DOCUMENT} from "@angular/common";

const defaultDialogConfig = new MatDialogConfig();


@Component({
    standalone: false,
  selector: "cloneSource-component",
  templateUrl: 'cloneSource.component.html',
  styleUrls: ['./cloneSource.component.scss'],
})

export class CloneSourceComponent implements OnInit {
  sourceId: number;
  projectId: number;
  project: Project;
  projectControlItems: ProjectControlItem[];
  targetProjectControlItems: ProjectControlItem[];

  projects: Project[];
  cols : any[] = [
    {'field': 'controlItem.complianceAreaControlId', 'header': 'Control ID'},
    {'field': 'controlItem.category', 'header': 'Category'},
    {'field': 'controlItem.shortName', 'header': 'Short Name'},
    {width: '20px'},
    {'field': 'controlItem.complianceAreaControlId', 'header': 'Control ID'},
    {'field': 'controlItem.category', 'header': 'Category'},
    {'field': 'controlItem.shortName', 'header': 'Short Name'},
  ]
  rowGroupMetadata: any;
  subVisible: any = {};
  sourceProjectControlItems: ProjectControlItem[];
  projectName: string;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public projectService: ProjectService,
    public projectControlItemService: ProjectControlItemService,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    @Inject(DOCUMENT) public document: any) {
    this.sourceId = route.snapshot.params['sourceId'] * 1;
    this.projectId = (route.snapshot.params['id'] || route.snapshot.params['sourceId']) * 1;
  }

  ngOnInit(): void {
    this.projectService.getAll().subscribe(pc => {
      this.projectService.getById(this.projectId).subscribe(p => {
        this.project = p;
        this.projectName = this.projectId == this.sourceId ? "Clone of " + p.name : p.name;
        if (this.projectId == this.sourceId) {
          let i = 1;
          while (pc.find(r => this.projectName == r.name)) {
            this.projectName = "Clone of " + p.name + " (" + i++ + ")";
          }
        }
        this.projects = pc.filter(s => (s.projectId != this.projectId || this.projectId == this.sourceId)/* && p.projectControlItems.find(t => s.projectControlItems.find(scc => scc.controlItemId == t.controlItemId))*/);
        this.targetProjectControlItems = p.projectControlItems;
        this.sourceId = this.sourceId == -1 ? this.projects.length ? this.projects[0].projectId : pc[0].projectId : this.sourceId;
        this.sourceProjectChange({value: this.sourceId});
      });
    });
  }

  sourceProjectChange($event) {
    this.projectService.getById(this.sourceId).subscribe(p => {
      this.sourceProjectControlItems = p.projectControlItems;
      this.projectControlItems = this.sourceProjectControlItems.filter(s => this.targetProjectControlItems.find(t => s.controlItem.controlItemId == t.controlItem.controlItemId));
      this.projectControlItems.forEach(i => {
        i.isCopied = this.sourceId == this.projectId || (i.targets.find(t => t.toProjectId == this.projectId) !== undefined);
//        i.isDisabled = false;
      });
      this.updateRowGroupMetaData(this.projectControlItems);
    });
  }

  toggleItems() {
    const opened = document.querySelectorAll(".fa-chevron-circle-down");
    const closed = document.querySelectorAll(".fa-chevron-circle-right");
    if (closed.length == 0) {
      Array.from(opened).forEach(i => (i as any).click());
    } else {
      Array.from(closed).forEach(i => (i as any).click());
    }
  }

  updateRowGroupMetaData(data) {
    this.rowGroupMetadata = {};
    if (data) {

      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        let brand = rowData.controlItem.category;
        if (i == 0) {
          this.rowGroupMetadata[brand] = {index: 0, size: 1};
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData.controlItem.category;
          if (brand === previousRowGroup) {
            this.rowGroupMetadata[brand].maturity += rowData.processMaturity;
            this.rowGroupMetadata[brand].size++;
          } else
            this.rowGroupMetadata[brand] = {index: i, size: 1};
        }
      }
    }
  }

  onSave() {
    if (this.projectId == this.sourceId) {
      const newProject = JSON.parse(JSON.stringify(this.project));
      newProject.projectId = 0;
      newProject.tenantName = LoginHelper.getTenantName();
      newProject.name = this.projectName;
      newProject.projectControlItems = this.projectControlItems.filter(i => i.isCopied);
      newProject.projectControlItems.forEach(i => {
        i.sources = [{fromId: i.projectControlItemId, kind: 1}];
        i.projectControlItemId = 0;
        i.isCloned = true;
      });
      this.projectService.create(newProject).subscribe((projectId) => {
        this.router.navigate(["/projects", "project", projectId]);
        const pairs = [];
      });
    } else {
      const pairs = [];
      this.projectControlItems.forEach(c => {
        if (c.isCopied) {
          pairs.push([c.projectControlItemId, this.targetProjectControlItems.find(t => t.controlItem.controlItemId == c.controlItem.controlItemId).projectControlItemId])
        } else {
          pairs.push([-1, this.targetProjectControlItems.find(t => t.controlItem.controlItemId == c.controlItem.controlItemId).projectControlItemId]);
        }
      });

      this.projectService.addPairings(this.sourceId, pairs).subscribe();
    }
  }

  getName(id) {
    return this.projects.find(p => p.projectId == id).name;
  }
}
